module.exports = "<div class=\"{{ style.header }}\"> {{ copy.title }} </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/entry/views/incompatible/incompatible.html
// module id = 413
// module chunks = 0